<script setup lang="ts">
import { VisuallyHidden } from 'reka-ui';

const props = defineProps<{
  label: string;
  required?: boolean;
  invalid?: boolean;
}>();

const model = defineModel<string>({ required: true });

// The layout gives the fields no captions — the placeholder carries the name
const placeholder = computed(() =>
  props.required ? `${props.label}*` : props.label,
);
</script>

<template>
  <label :class="$style.field">
    <!--
      The label wraps the input, so it needs no id; hidden because the layout
      shows the name in the placeholder, kept because a placeholder alone
      leaves a screen reader with nothing once the field is filled in
    -->
    <VisuallyHidden>{{ placeholder }}</VisuallyHidden>
    <Input
      v-model="model"
      type="text"
      :placeholder="placeholder"
      :error="invalid"
      :class="$style.input"
    />
  </label>
</template>

<style module lang="scss">
.field {
  display: block;
  height: 60px;
}

.input {
  height: 100%;
}

@media (max-width: 599px) {
  .field {
    height: 56px;
  }
}
</style>
